module.exports = __webpack_public_path__ + "img/three-screens.5d94eff0.webp";